import React from 'react';
import { useFormGeneratorField } from '../hooks/useFormGeneratorField';
import UniFormcompoErrorInField from './UniFormcompoErrorInField';

const UniFormgenInputCheckbox = (props) => {
  const {
    warningtip,
    // valueToDisplay,
  } = useFormGeneratorField(props);

  let params = {};
  if (props.params) {
    params = props.params;
  }
  let readonly = false;
  if (params.readonly === true) {
    readonly = true;
  }
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }
  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }
  let handleChange = null;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  }
  if (readonly === true) {
    /*
    It's important to understand that READONLY merely prevents the user from changing the value of the field, not from interacting with the field. In checkboxes, for example, you can check them on or off (thus setting the CHECKED state) but you don't change the value of the field.
    */
    // handleChange = () => { }; // disable handle change for readonly
    handleChange = null; // disable handle change for readonly
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  let cl = 'uniformcompo__field' + extraClass;
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }

  let style = {};
  if (params.w > 0) {
    style.width = params.w;
  }

  const infotip = 'name: ' + name;

  return (
    <div className={cl} style={style}>
      <label className="uniformcompo__label-wrapping-checkbox" htmlFor={name}>
        <span className="label">{params.label}</span>
        <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
          <input
            type="checkbox"
            name={name}
            readOnly={readonly}
            disabled={readonly}
            checked={formState[name]}
            onChange={handleChange}
            className="uu-anyinput-control-checkbox"
          />
        </span>
      </label>
      <div className="uniformcompo__field__infotip-container uniformcompo__field__infotip-container--chekbox-mode"><div className="uniformcompo__field__infotip">{infotip}</div></div>
      {
        warningtip ? (
          <div className="uniformcompo__field__warningtip-container"><div className={"uniformcompo__field__warningtip" + (" frfr-js-tinytag frfr-js-tinytag--primitive-value-type--" + warningtip)}>{warningtip}</div></div>
        ) : null
      }
    </div>
  );
};

export default UniFormgenInputCheckbox;